import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { useTranslate, useValidate } from 'hooks';
import { Input } from 'views/components/sz/ui/input';

type EmailFormType = {
  email: '';
};

const EmailField = () => {
  const { control, setFocus } = useFormContext<EmailFormType>();

  const { validateEmail } = useValidate();
  const { t } = useTranslate();

  useEffect(() => {
    setFocus('email');
  }, [setFocus]);

  return (
    <Controller
      name="email"
      control={control}
      rules={{ required: true, validate: validateEmail }}
      render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
        <Input
          isEmail
          ref={ref}
          name="email"
          label={t('enter_email_base')}
          placeholder="username@gmail.com"
          value={value}
          inputClassName="w-full bg-[transparent]"
          onChange={onChange}
          error={error?.message}
        />
      )}
    />
  );
};

export { EmailField };
